import { render, staticRenderFns } from "./ProfileSif.vue?vue&type=template&id=67b3a4a2&scoped=true&"
import script from "./ProfileSif.vue?vue&type=script&lang=js&"
export * from "./ProfileSif.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSif.vue?vue&type=style&index=0&id=67b3a4a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b3a4a2",
  null
  
)

export default component.exports